"use strict";

(function (Drupal, once) {
  Drupal.behaviors.notificationBar = {
    attach: function attach(context, settings) {
      var notification = document.querySelectorAll('.layout-container .notification');
      if (!notification.length) {
        return;
      }
      once('notificationProcessed', '.layout-container .notification', context).forEach(function () {
        var notification = $(this);
        if (!notification || document.body.classList.contains('layout-builder--is-enabled')) {
          return;
        }
        document.body.classList.add('has-notification');
      });
    }
  };
})(Drupal, once);